import { DEFAULT_CONFIG } from '@/utils/config';
import storage from '@/utils/storage';

export const updateConfig = (configData: any) => {
  const defaultConfig = DEFAULT_CONFIG;
  const config = { ...defaultConfig, ...configData };
  storage.setItem('config', config);
  const bottombars = config?.bottombars || [];
  storage.setItem('bottombars', bottombars);

  let currencySymbol = '₹';
  if (config?.currency_symbol) {
    currencySymbol = config?.currency_symbol ? config?.currency_symbol : '₹';
  }
  storage.setItem('currency_symbol', currencySymbol);
};

export const checkLoginMethod = (config: any) => {
  let renderLogin;
  if (storage.getItem('currentUser')) {
    return;
  }
  if (!config?.auth_skip) {
    if (storage.getItem('event_flow')) {
      renderLogin = false;
      // navigate to loginMobileOtp
      window.location.href = 'loginMobileOtp';
    } else if (config?.otp_login) {
      renderLogin = false;
      window.location.href = 'loginMobileOtp';
    } else {
      renderLogin = true;
    }
  } else {
    renderLogin = true;
  }
  storage.setItem('renderLogin', renderLogin);
};

export const updateCompany = (companyData: any) => {
  const company = companyData;
  storage.setItem('company', company);
  let currentLocation = storage.getItem('currentLocation');
  const config = storage.getItem('config');
  const currentUser = storage.getItem('currentUser');

  const locationMapping: any = {};
  const noOfLocations = company?.locations?.data?.length;
  for (let i = 0; i < noOfLocations; i++) {
    locationMapping[company.locations.data[i].id] = company.locations.data[i];
  }
  storage.setItem('locationMap', locationMapping);
  const pwaQRLocationId = storage.getItem('pwaQRLocationId');

  if (pwaQRLocationId) {
    currentLocation =
      locationMapping[pwaQRLocationId] ?? locationMapping[Object.keys(locationMapping)[0]];
    storage.setItem('currentLocation', currentLocation);
    sessionStorage.setItem('currentLocation', JSON.stringify(currentLocation));
  }

  if (config?.auth_skip && !currentLocation && noOfLocations > 0 && !currentUser) {
    // eslint-disable-next-line prefer-destructuring
    currentLocation = company.locations.data[0];

    currentLocation.auth_skip = true;
  }

  if (currentLocation?.company_ids !== config?.company_id?.toString()) {
    // eslint-disable-next-line prefer-destructuring
    currentLocation = company.locations.data[0];
  }
  if (currentUser && !currentLocation && noOfLocations > 0) {
    // eslint-disable-next-line prefer-destructuring
    currentLocation = company.locations.data[0];
  }
  storage.setItem('currentLocation', currentLocation);
};
